import { appendIf } from '@btime/helpers'
import { gql, useMutation } from '@apollo/client'
import { useTranslation } from 'react-i18next'

import { cleanRequest } from './cleanRequest'
import { stocksClient } from '../../../../utils/apollo/api'

const MUTATION = gql`
  mutation InsertStockItemOperations($inputs: [StockItemOperationInput]) {
    insertStockItemOperations(inputs: $inputs) {
      client_code
      status
    }
  }
`

const validate = (form, setErrors, t) => {
  const allowed_value_lte_zero = ['set_general_stock']
  const errors = form.reduce(
    (errors, item, index) => [
      ...errors,
      ...appendIf(!item.item, { path: [index, 'item'], message: t('bulkTransfer.validation.required') }),
      ...appendIf(!item.amount, { path: [index, 'amount'], message: t('bulkTransfer.validation.required') }),
      ...appendIf(item.amount != null && item.amount < 0, {
        path: [index, 'amount'],
        message: t('bulkTransfer.validation.amountNotNegative')
      }),
      ...appendIf(item.amount == 0 && !allowed_value_lte_zero.includes(item.operationType?.id), {
        path: [index, 'amount'],
        message: t('bulkTransfer.validation.amountGreaterThanZero')
      }),
      ...appendIf(!item.operationType, {
        path: [index, 'operationType'],
        message: t('bulkTransfer.validation.required')
      }),
      ...appendIf(
        (item.operationType?.id === 'transfer_from_general_to_user' ||
          item.operationType?.id === 'transfer_from_user_to_general' ||
          item.operationType?.id === 'self_use') &&
          !item.user,
        { path: [index, 'user'], message: t('bulkTransfer.validation.required') }
      )
    ],
    []
  )

  setErrors(errors)
  return errors.length === 0
}

export const useSendTransfers = () => {
  const { t } = useTranslation('editStocks')
  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['StockItems'],
    client: stocksClient
  })

  const handleRequest = async (form, actions) => {
    const inputs = cleanRequest(form.filter(item => item.status !== 'success'))
    const { setErrors, handleChangeIn } = actions
    const isValid = validate(form, setErrors, t)

    if (isValid) {
      request({ variables: { inputs } }).then(resp => {
        if (!resp.errors) {
          const { data } = resp

          const findIndex = clientCode => {
            return form.findIndex(item => {
              return item.clientCode === clientCode
            })
          }

          data.insertStockItemOperations.forEach(item => {
            const index = findIndex(item.client_code)
            handleChangeIn([index, 'status'], item.status)
          })
        }
      })
    }
  }

  return [handleRequest, state]
}
